import {create} from "zustand";
import {createJSONStorage, persist} from "zustand/middleware";
import {Subscription} from "../types/Subscription";
import apiService from "../hooks/apiService";
import {useSnackbarStore} from "./snackbarStore";

interface Plan {
    id: string;
    country: string;
}

interface PaypalStore {
    plan: Plan[];
    subscriptionInfo: Subscription
    buyerCountry: string;

    getSubscriptionInfo: (userId: number) => void;
    setSubscriptionInfo: (subInfo: Subscription) => void;
    detectUserCountry: () => void;
    getPlan: () => Plan;
}

interface IpApi {
    country_code: string;

    [key: string]: any;
}


function base64ToBlob(base64: string, mime = "application/pdf") {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], {type: mime});
}

export const usePaypalStore = create(persist<PaypalStore>(
    (set, get) => ({
        plan: [{
            id: "P-61F74735B7380573YNCDVV4I",
            country: "DE"
        }],
        subscriptionInfo: {} as Subscription,
        euCountries: [],
        buyerCountry: "",

        getPlan: () => {
            const plan = get().plan;
            const buyerCountry = get().buyerCountry;

            const plans = plan.filter(plan => plan.country === buyerCountry);
            if (plans.length === 1) {
                return plans[0];
            }
            return {} as Plan;
        },

        getSubscriptionInfo: async (userId: number) => {
            if (userId === -1) {
                return;
            }
            const snackbar = useSnackbarStore.getState();
            apiService.getSubscriptionInfo(userId).then(response => {
                if (!response.data) {
                    return;
                }
                const subInfo = {
                    status: response.data.status,
                    renews_at: response.data.renewsAt,
                    grace_period_ends_at: response.data.gracePeriodEndsAt,
                    invoices: response.data.invoices.map((blob: string) => {
                        return base64ToBlob(blob);
                    })
                }
                set({subscriptionInfo: subInfo})
            }).catch(error => {
                snackbar.showSnackbar("could not load subscription info: " + error.message, "error")
            })
        },
        setSubscriptionInfo: (response: any) => {
            const s = {
                renews_at: response.renewsAt,
                grace_period_ends_at: response.gracePeriodEndsAt,
                invoices: response.invoices,
                status: response.status
            }
            set({subscriptionInfo: s})
        },
        detectUserCountry: async () => {
            try {
                let ip = get().buyerCountry;
                if (ip.length === 2) {
                    return;
                }
                const res = await fetch('https://ipapi.co/json/');
                if (!res.ok) {
                    set({buyerCountry: 'DE'})
                }
                res.json().then((data: IpApi) => {
                    console.log(data);
                    set({buyerCountry: data.country_code})
                })
            } catch (error) {
                set({buyerCountry: 'DE'})
            }
        },

    }), {
        name: "ip-storage",
        storage: createJSONStorage(() => localStorage),
    }));
